import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AgentApiAllianceAgentsItem, AgentUserStatus } from '@/types/serializers';
import { ALLIANCE_AGENTS_QUERY_KEY } from './useFetchAllianceAgents';
import { ALLIANCE_AGENTS_METADATA_QUERY_KEY } from './useFetchAllianceAgentsMetadata';

interface UpdateAllianceAgentParams {
  id: number;
  name?: string;
  email?: string;
  status?: AgentUserStatus;
}

export default function useUpdateAllianceAgent() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...params }: UpdateAllianceAgentParams) => {
      const response = await fetch(`/agent/api/alliance_agents/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ alliance_agent: params }),
      });

      if (!response.ok) {
        let errorMessage = 'エージェント情報の更新に失敗しました';
        try {
          const errorData: { error?: string; errors?: string[] } = await response.json();
          errorMessage = errorData.errors?.[0] || errorData.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: AgentApiAllianceAgentsItem = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALLIANCE_AGENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: ALLIANCE_AGENTS_METADATA_QUERY_KEY });
    },
  });
}
